import React, { useState } from 'react';
import {
  TextField,
  InputAdornment,
  IconButton,
  Tooltip,
  Box,
} from '@material-ui/core';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import FileCopyIcon from '@material-ui/icons/FileCopy';

interface ZipPasswordWidgetProps {
  password: string;
}

export const ZipPasswordWidget: React.FC<ZipPasswordWidgetProps> = ({ password }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [copied, setCopied] = useState(false);

  const handleToggleVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(password);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Box my={2} style={{ maxWidth: 400 }}>
      <TextField
        fullWidth
        variant="outlined"
        size="small"
        label="Mot de passe de l'archive ZIP"
        type={showPassword ? 'text' : 'password'}
        value={password}
        InputProps={{
          readOnly: true,
          endAdornment: (
            <InputAdornment position="end">
              <Tooltip title={showPassword ? "Masquer" : "Afficher"}>
                <IconButton onClick={handleToggleVisibility} edge="end" aria-label="toggle password visibility">
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </Tooltip>

              <Tooltip title={copied ? "Copié !" : "Copier le mot de passe"}>
                <IconButton onClick={handleCopy} edge="end" aria-label="copy password">
                  <FileCopyIcon />
                </IconButton>
              </Tooltip>
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
};
